import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kspb_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export const COMPANY = {
  name: "KSPB ENTERPRISES LLP",
  short: "KSPB",
  email: "kspbenterprisesllp@gmail.com",
  phone: "8005841071",
  phoneDisplay: "+91 80058 41071",
  whatsapp: "918005841071",
  location: "Jaipur, Rajasthan, India",
  gst: "",
  logo: "https://customer-assets-lqy194kg.emergentagent.net/job_fleet-tracker-pro-9/artifacts/90ezcsmt_IMG-20260812-WA0008.jpg",
};

export const fmtINR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);
